<div id="ht">
  <div id="main-cnt">
    <ion-header class="main-header block">
      <ion-toolbar class="blues-nav">
        <ion-buttons slot="start" class="nav-content">
          <div size="2" class="nav-back">
            <span class="custom-icon-back-arrow-icon" (click)="back()">
              <span class="path1"></span>
              <span class="path2"></span>
            </span><ion-icon class="ion-padding-start" size="large" name="home" (click)="sessionService.gotoHome()"></ion-icon>
            <span *ngIf="profile === 'clients'" class="breadcrumb"
              ><span *ngIf="sessionService.user?.permessions === 'ADMINISTRATOR'"
                >AMMINISTRATORE - </span
              >COMMERCIALE - I MIEI CLIENTI - ELENCO</span
            >
            <span *ngIf="profile === 'education'" class="breadcrumb"
              ><span *ngIf="sessionService.user?.permessions === 'ADMINISTRATOR'"
                >AMMINISTRATORE - </span
              >COMMERCIALE - I MIEI CLIENTI - CONTRATTI</span
            >
            <span *ngIf="profile === 'summary'" class="breadcrumb"
              ><span *ngIf="sessionService.user?.permessions === 'ADMINISTRATOR'"
                >AMMINISTRATORE - </span
              >COMMERCIALE - I MIEI CLIENTI - REPORT</span
            >
          </div>
        </ion-buttons>
        <div slot="end" class="notification-div">

          <ion-avatar class="menu-user-icon" (click)="openPage('/my-profile')">
            <img [src]="sessionService?.user?.profileImg|s3Link" />

          </ion-avatar>
        </div>
        <app-add-bookmark slot="end"
                pageTitle="Clienti"
                url="/clients"
        ></app-add-bookmark>
      </ion-toolbar>
      <br />

      <!-- edit da qui... -->
      <div class="glass-blurred-background panel-buttons-container">
        <div
          class="panel-button theme-text-color"
          [class.active]="currentPanel === 'elenco'"
          (click)="currentPanel = 'elenco'"
        >
          <div class="panel-button-image-container">
            <img
              class="panel-button-image svg-white"
              src="./assets/imgs/elenco.svg"
            />
          </div>
          <h4>Elenco</h4>
        </div>
        <div
          class="panel-button theme-text-color"
          [class.active]="currentPanel === 'contratti'"
          (click)="currentPanel = 'contratti'"
        >
          <div class="panel-button-image-container">
            <img
              class="panel-button-image svg-white"
              src="./assets/imgs/contratti.svg"
            />
          </div>
          <h4>Contratti</h4>
        </div>
      </div>

      <!-- <div class="flex-collapsible" *ngIf="currentPanel == 'contratti'">
            <div class="flex-row header" (click)="showFilters = !showFilters">              
              <div class="flex-1 text-center">
                <img class="svg-white vertical-middle xsmall" src="./assets/imgs/search.svg">
                Ricerca
                <img class="svg-white vertical-middle xsmall" src="./assets/imgs/filter.svg">
              </div>              
            </div>
        
            <div class="panel" *ngIf="showFilters">       
              <div style="text-align: center;padding: 1rem;">
                Scadenza <input type="date" style="margin-left: 1rem;">              
              </div>       
            </div>        
          </div> -->

      <h3 class="panel-title" *ngIf="currentPanel === 'elenco'">Clients</h3>
      <h3 class="panel-title" *ngIf="currentPanel === 'contratti'">Contracts</h3>
      <!-- ...a qui -->
    </ion-header>

    <ion-content class="main-content">
      <div class="scroller-container">
        <div class="content-scroller">
          <div class="content">
            <!-- edit da qui... -->

            <div class="flex-panel" *ngIf="currentPanel === 'elenco'">
              <div class="flex-collapsible">
                <div
                  class="flex-row header"
                  (click)="showFilters = !showFilters"
                >
                  <div class="flex-1 text-center">
                    <img
                      class="svg-white vertical-middle xsmall"
                      src="./assets/imgs/search.svg"
                    />
                    Ricerca
                    <img
                      class="svg-white vertical-middle xsmall"
                      src="./assets/imgs/filter.svg"
                    />
                  </div>
                </div>

                <div class="panel" *ngIf="showFilters">
                  <div style="text-align: center; padding: 1rem">
                    <input
                      [(ngModel)]="filters.name"
                      name="name"
                      class="text-input full-width block"
                      placeholder="Ricerca per nome"
                      type="search"
                      (keyup)="filterUsers()"
                    />

                    <div class="flex-row">
                      <div class="flex-1 text-left">Data iscrizione</div>
                      <div class="flex-1 text-right">
                        <input
                          class="text-input"
                          type="date"
                          style="margin-left: 1rem"
                          (change)="$event"
                        />
                      </div>
                    </div>

                    <div class="flex-row">
                      <div class="flex-1 text-left">Escludi inattivi</div>
                      <div class="flex-1 text-right">
                        <input type="checkbox" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <app-clients-list
                      [showCommerciale]="true"
                [owner]="sessionService.user"
                #usersList
              ></app-clients-list>
            </div>

            <div class="flex-panel" *ngIf="currentPanel === 'contratti'">
              <app-contracts-list
                [owner]="sessionService.user"
              ></app-contracts-list>
            </div>

            <!-- ...a qui -->
          </div>
        </div>
      </div>
    </ion-content>
  </div>
</div>
